import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormState } from 'react-final-form';
import { upperFirst } from 'lodash';

import { Box, RFFReactSelect } from '@qwealth/qcore';
import { selectPartners } from '@qwealth/qdata';
import { RFFMaskedDateField } from '@qwealth/kyc';

import {
  KypFilteringDateOptions,
  KypFilters,
  KypSelectableApprovedForValues,
  KypSelectableTypeValues,
  KypSortOption,
  KypSortOptions,
  KypStatusValues,
} from 'data/models/Kyp';
import { getKyps, setKypSortBy, setKypSortingDate } from 'data/actions/KYP';
import { kypFilterDateOptionToDateKeyMap } from 'data/refData/kyp';

const KypFilterForm: FC = (): JSX.Element => {
  const { values } = useFormState();
  const [sortBy, setSortBy] = useState<KypSortOption | undefined>();
  const partners = useSelector(selectPartners);
  const dispatch = useDispatch();

  useEffect(() => {
    setSortBy(values.sortBy as KypSortOption);
    dispatch(setKypSortingDate(values.filteringDate ? kypFilterDateOptionToDateKeyMap[values.filteringDate] : undefined));
    dispatch(getKyps(values as KypFilters));
  }, [values]);

  useEffect(() => {
    dispatch(setKypSortBy(sortBy));
  }, [sortBy]);

  return (
    <Box display="flex" flexDirection="row" flexWrap="wrap" justifyContent="space-between" marginBottom="large">
      <Box width="20vh">
        <RFFReactSelect
          key="KypTypeFilter"
          name="type"
          label="Type"
          inputFieldProps={{
            options: [...KypSelectableTypeValues],
            isClearable: true,
          }}
        />
      </Box>

      <Box width="20vh">
        <RFFReactSelect
          key="KypPartnerFilter"
          name="partner"
          label="Partner"
          inputFieldProps={{
            options: partners,
            isClearable: true,
            toLabel: value => value.partnerName,
            toValue: value => {
              return value == null ? null : value.id;
            },
          }}
        />
      </Box>

      <Box width="20vh">
        <RFFReactSelect
          key="kypReviewStatus"
          name="reviewStatus"
          label="Review Status"
          inputFieldProps={{
            options: [...KypStatusValues],
            toLabel: value => upperFirst(value),
            isClearable: true,
          }}
        />
      </Box>

      <Box width="20vh">
        <RFFReactSelect
          key="kypApprovedFor"
          name="approvedFor"
          label="Approved For"
          inputFieldProps={{
            options: [...KypSelectableApprovedForValues],
            isClearable: true,
          }}
        />
      </Box>

      <Box width="20vh">
        <RFFReactSelect
          key="kypFilteringDate"
          name="filteringDate"
          label="Filtering Date"
          inputFieldProps={{
            options: [...KypFilteringDateOptions],
          }}
        />
      </Box>

      <Box width="20vh">
        <RFFMaskedDateField name={'startDate'} label="Starting" />
      </Box>

      <Box width="20vh">
        <RFFMaskedDateField name={'endDate'} label="Ending" />
      </Box>

      <Box width="20vh">
        <RFFReactSelect
          name={'sortBy'}
          label="Sort"
          value={sortBy}
          inputFieldProps={{
            options: [...KypSortOptions],
          }}
        />
      </Box>
    </Box>
  );
};

export default KypFilterForm;
